import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, QueryList, ViewChildren } from '@angular/core';
import { AbstractIndexArticle } from '../../abstract-index-article';
import { TranslateService } from '@ngx-translate/core';
import { CommonHttpClientService } from '../../../../../../share/service/common-http-client.service';
import { ServerConfigService } from '../../../../../../share/service/server-config.service';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from '../../../../../generator-env-token';
import { Section } from '../../../../../template-generator/entity/section';
import { TemplateService } from '../../../../../template-generator/service/template.service';
import { SECTION_DATA } from '../../../../service/section-data';
import { CmsNormal } from '../../../../../cms-generator/module/cms-normal/cms-normal';
import { IndexArticle } from '../../index-article';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-index-article-02',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent extends AbstractIndexArticle implements AfterViewInit, OnDestroy {
  belongSiteModules = ['NORMAL'];
  limit = 10000;
  defaultData: any = {
    title: '最新消息',
    cannotDel: true,
  };
  remoteDefaultData: IndexArticle[] = [
    {
      id: 0,
      title: '【海風中的歲月-臺灣漁民的日常與傳承】修補漁網的技藝有何特…',
      description: '',
      categories: ['網站公告'],
      openStartDate: '2024-10-29T19:00:00.000',
      images: [{
        id: 0,
        name: '1000x660-14',
        ext: 'webp',
        objectName: '',
        otherInfos: {},
        transform: {
          comp: '/assets/images/v001/1000x660-14.webp'
        },
        url: '/assets/images/v001/1000x660-14.webp'
      }],
      onTop: false,
    },
    {
      id: 0,
      title: '礦工生命記憶',
      description: '',
      categories: ['網站公告'],
      openStartDate: '2024-10-29T19:00:00.000',
      images: [{
        id: 0,
        name: '1000x660-15',
        ext: 'webp',
        objectName: '',
        otherInfos: {},
        transform: {
          comp: 'assets/images/v001/1000x660-15.webp'
        },
        url: '/assets/images/v040/1000x660-15.webp'
      }],
      onTop: false,
    },
    {
      id: 0,
      title: '【人人講堂精彩花絮】在歷史的碎片中，我們尋',
      description: '',
      categories: ['網站公告'],
      openStartDate: '2024-10-29T19:00:00.000',
      images: [{
        id: 0,
        name: '1000x660-16',
        ext: 'webp',
        objectName: '',
        otherInfos: {},
        transform: {
          comp: 'assets/images/v001/1000x660-16.webp'
        },
        url: '/assets/images/v040/1000x660-16.webp'
      }],
      onTop: false,
    },
    {
      id: 0,
      title: '【精彩回顧】 2024 國家文化記憶庫國際論壇圓',
      description: '',
      categories: ['網站公告'],
      openStartDate: '2024-10-29T19:00:00.000',
      images: [{
        id: 0,
        name: '1000x660-17',
        ext: 'webp',
        objectName: '',
        otherInfos: {},
        transform: {
          comp: 'assets/images/v001/1000x660-17.webp'
        },
        url: '/assets/images/v040/1000x660-17.webp'
      }],
      onTop: false,
    }
  ];
  /** 選單擁有的分類項目 */
  categories: string[] = [];
  /** 依照分類進行分組後的多筆資料列 */
  listGroupedByCategory: Record<string, IndexArticle[]> = {};
  @ViewChildren('tabPane') tabPanes: QueryList<ElementRef>;
  _tabPaneRefChangeSubc: Subscription;

  constructor(
    @Inject(SECTION_DATA) protected section: Section,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected serverConfigService: ServerConfigService,
    protected translate: TranslateService,
    protected http: CommonHttpClientService,
    protected templateService: TemplateService,
  ) {
    super(section, generatorEnv, platformId, serverConfigService, translate, http, templateService);
  }

  ngAfterViewInit(): void {
    if (this.categories && this.categories.length && this.tabPanes) {
      if ((this.tabPanes.length - 1) === this.categories.length) {
        const el = this.tabPanes.first.nativeElement as HTMLElement;
        if (!el.classList.contains('active')) {
          el.classList.add('show');
          el.classList.add('active');
        }
      } else {
        this._startWatchTabPaneRefsChange();
      }
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this._stopWatchTabPaneRefsChange();
  }

  /** 監看 tab pane 數量變更，如果有多個則將第一個 tab 顯示到 active 狀態 */
  protected _startWatchTabPaneRefsChange() {
    if (!this.tabPanes) { return; }
    this._stopWatchTabPaneRefsChange();
    this._tabPaneRefChangeSubc = this.tabPanes.changes.subscribe(changes => {
      if (this.categories && this.categories.length && (this.tabPanes.length - 1) === this.categories.length) {
        const el = this.tabPanes.first.nativeElement as HTMLElement;
        if (!el.classList.contains('active')) {
          el.classList.add('show');
          el.classList.add('active');
        }
      }
    });
  }

  /** 停止監看 tab pane 數量變更 */
  protected _stopWatchTabPaneRefsChange() {
    if (this._tabPaneRefChangeSubc) {
      this._tabPaneRefChangeSubc.unsubscribe();
      delete this._tabPaneRefChangeSubc;
    }
  }

  /** 初始化區塊資料 */
  protected initData() {
    const defaultDataClone = JSON.parse(JSON.stringify(this.defaultData));
    if (this.section.data) {
      Object.assign(defaultDataClone, this.section.data);
      Object.assign(this.section.data, defaultDataClone);
    } else {
      this.section.data = defaultDataClone;
    }

    this.onRmtDataSetted(JSON.parse(JSON.stringify(this.remoteDefaultData)));

    this.refreshRemoteData();
  }

  refreshRemoteData(args?: any[]) {
    const path = this.section.data.path;
    const moduleKey = this.section.data.moduleKey;

    if (path && moduleKey) {
      this.http.get<{total: number, rows: Array<CmsNormal>}>(`${this.generatorEnv.apiHost}/api/${this.translate.currentLang}/cm/${moduleKey.toLocaleLowerCase()}/${path}`, {
        params: {
          page: this.offset / this.limit,
          size: this.limit,
          sort: ['open_start_date,desc']
        }
      }).subscribe(data => {
        const indexArticles = data.rows.map(item => ({
          id: item.id,
          title: item.title,
          description: item.description,
          categories: item.categories || [],
          createDate: item.createDate,
          modifyDate: item.modifyDate,
          openStartDate: item.openStartDate,
          keywords: [],
          images: item.repImage ? [item.repImage] : [],
          onTop: false,
        }));
        this.onRmtDataSetted(indexArticles);
        
        if (this.dataSourceLock) {
          this.dataSourceLock.unlock();
        }
      }, error => {
        this.onRmtDataSetted(JSON.parse(JSON.stringify(this.remoteDefaultData)));
        if (this.dataSourceLock) {
          this.dataSourceLock.unlock();
        }
      });
    }
  }

  /** 設定遠端列表資料 */
  protected onRmtDataSetted(rmtDatas: IndexArticle[]) {
    this.remoteData = rmtDatas;

    // 將資料依照分類進行分組
    this.listGroupedByCategory = rmtDatas.reduce((acc, item) => {
      if (item.categories && item.categories.length) {
        item.categories.forEach(category => {
          if (!acc[category]) { acc[category] = []; }
          acc[category].push(item);
        });
      } else {
        const category = '未分類'
        if (!acc[category]) { acc[category] = []; }
        acc[category].push(item);
      }
      return acc;
    }, {} as Record<string, IndexArticle[]>);

    // // 提取分類名稱並根據該分類的項目數降冪排序
    // const sortedCategories = Object.keys(this.listGroupedByCategory).sort((a, b) => {
    //   return this.listGroupedByCategory[b].length - this.listGroupedByCategory[a].length;
    // })
    // .filter(c => this.listGroupedByCategory[c].length >= 4); // 資料量大於等於4筆才保留
    // this.categories = sortedCategories.slice(0, 3); // 只取前三筆顯示

    // 後來說要用固定的，所以上面那段註解掉改這段
    const newCategories = ['網站公告', '活動訊息', '新聞稿']
    .filter(c => this.listGroupedByCategory[c] && this.listGroupedByCategory[c].length > 0);
    let lenChanged = false;
    if (this.categories.length !== newCategories.length) {
      lenChanged = true;
    }
    this.categories = newCategories;  
    // if (lenChanged) {
      this._startWatchTabPaneRefsChange();
    // }
  }
}
